import { Resume } from "lib/redux/types";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";

// Helper function to calculate word count for a given text
export const calculateWordCount = (text?: string): number => {
  return text ? text.split(/\s+/).filter(Boolean).length : 0; // Handle undefined or null text
};

// Helper function to calculate word count for an object
const calculateObjectWordCount = (obj?: Record<string, any>): number => {
  if (!obj) return 0; // Handle undefined or null object
  let wordCount = 0;
  Object.values(obj).forEach((value) => {
    if (typeof value === "string") {
      wordCount += calculateWordCount(value);
    } else if (Array.isArray(value)) {
      value.forEach((item) => {
        if (typeof item === "string") {
          wordCount += calculateWordCount(item);
        } else if (typeof item === "object" && item !== null) {
          wordCount += calculateObjectWordCount(item); // Recursive for nested objects
        }
      });
    } else if (typeof value === "object" && value !== null) {
      wordCount += calculateObjectWordCount(value); // Recursive for nested objects
    }
  });
  return wordCount;
};

const calculateWordCountScore = (resume?: ResumeAnalysis): number => {
  let totalWordCount = 0;

  // Add words from core sections
  totalWordCount += calculateObjectWordCount(resume?.profile);

  resume?.workExperiences?.individualWorkExperiencesAnalysis?.forEach((experience) => {
    totalWordCount += calculateObjectWordCount(experience);
  });

  resume?.educations?.individualEducationsAnalysis?.forEach((education) => {
    totalWordCount += calculateObjectWordCount(education);
  });

  resume?.projects?.individualProjectsAnalysis?.forEach((project) => {
    totalWordCount += calculateObjectWordCount(project);
  });

  totalWordCount += calculateObjectWordCount(resume?.skills);

  // Add words from non-core sections if they are present
  resume?.certifications?.individualCertificatesAnalysis?.forEach((certificate) => {
    totalWordCount += calculateObjectWordCount(certificate);
  });

  resume?.languages?.individualLanguagesAnalysis?.forEach((language) => {
    totalWordCount += calculateObjectWordCount(language);
  });

  resume?.awards?.individualAwardsAnalysis?.forEach((award) => {
    totalWordCount += calculateObjectWordCount(award);
  });

  totalWordCount += calculateObjectWordCount(resume?.custom);

  
  // console.log("Total Word Count: ", totalWordCount);
  return totalWordCount;
};

export default calculateWordCountScore;

// import { Resume } from "lib/redux/types";

// // Helper function to calculate word count for a given text
// const calculateWordCount = (text: string): number => {
//   return text.split(/\s+/).filter(Boolean).length;
// };

// const calculateWordCountScore = (resume: Resume): number => {
//   let totalWordCount = 0;

//   // Add words from each relevant section
//   totalWordCount += calculateWordCount(resume.profile.summary);

//   resume.workExperiences.forEach((experience) => {
//     experience.descriptions.forEach((desc) => {
//       totalWordCount += calculateWordCount(desc);
//     });
//   });
// //
//   resume.educations.forEach((education) => {
//     education.descriptions.forEach((desc) => {
//       totalWordCount += calculateWordCount(desc);
//     });
//   });

//   resume.projects.forEach((project) => {
//     project.descriptions.forEach((desc) => {
//       totalWordCount += calculateWordCount(desc);
//     });
//   });

//   resume.skills.descriptions.forEach((desc) => {
//     totalWordCount += calculateWordCount(desc);
//   });

//   // Calculate the word count score based on the total word count
//   let wordCountScore = 5; // Max score is 5
//   if (totalWordCount < 400) {
//     // Deduct points for word count less than 400
//     wordCountScore = 5 - Math.max(Math.ceil((400 - totalWordCount) / 50), 5);
//   } else if (totalWordCount > 600) {
//     // Deduct points for word count more than 600
//     wordCountScore = 5 - Math.max(Math.ceil((totalWordCount - 600) / 50), 5);
//   }

//   return wordCountScore;
// };

// export default calculateWordCountScore;
